import { AccountStatus } from 'cat-shared/utils'
import { AppBlobImage, AppPopup, Size } from 'client/ui-building-blocks'
import { getUserAvatarUrl, getAssetUrl, getAccountStatus } from 'client/services'
import { useAppContext, useEnvContext, usePage } from 'client/hooks'

type Props = {
  userId: string
  size?: Size
  rounded?: boolean
  popupContent?: string
  hideIfAdmin?: boolean
  profileLink?: 'NAVIGATE' | 'NEW_TAB'
}

const UserAvatar = ({
  userId,
  size = 'medium',
  rounded = true,
  popupContent,
  hideIfAdmin = false,
  profileLink,
}: Props) => {
  const { authUser } = useAppContext()
  const { awsBucketUrl, adminUserId } = useEnvContext()
  const { navigateTo } = usePage()

  const accountStatus = getAccountStatus(authUser)

  if (hideIfAdmin && userId === adminUserId) {
    return null
  }

  const onClick = () => {
    if (profileLink === 'NAVIGATE') {
      navigateTo({
        path: '/profile',
        query: { _id: userId },
      })
    } else if (profileLink === 'NEW_TAB') {
      window.open('/profile?_id=' + userId, '_blank')
    }
  }

  return (
    <AppPopup text={popupContent}>
      <AppBlobImage
        size={size}
        rounded={rounded}
        src={getUserAvatarUrl(awsBucketUrl, userId)}
        defaultImg={getAssetUrl('avatar-default.png')}
        onClick={
          accountStatus !== AccountStatus.UNKNOWN && userId !== adminUserId
            ? onClick
            : undefined
        }
      />
    </AppPopup>
  )
}

export default UserAvatar
